import React from 'react';
import './ExecutionPlanSection.css';

const dayOne = [
  'Pick one business model and one audience.',
  'Write one starter offer using: I help [audience] achieve [result] without [pain].',
  'Create one proof asset (sample, case format, or mock project).',
  'List 25 potential buyers or 25 content topics.',
  'Send first 10 outreach messages or publish first piece of content.',
];

const weekly = [
  'Week 1: Clarity, offer, and setup',
  'Week 2: Outreach volume and follow-ups',
  'Week 3: Calls, proposals, and first closes',
  'Week 4: Delivery quality, testimonials, and repeatable system',
];

const ExecutionPlanSection = ({ sectionNumber = '03' }) => (
  <section className="execution-section" id="execution" title={sectionNumber}>
    <div className="execution-container">
      <div className="execution-intro">
        <h2>Execution Plan That Gets Results</h2>
        <p>Built from the Execution Edition to move from reading to real action.</p>
      </div>

      <div className="execution-panels">
        <article className="execution-panel">
          <h3>Day 1 Setup</h3>
          <ul>
            {dayOne.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </article>

        <article className="execution-panel">
          <h3>30-Day Launch Sprint</h3>
          <ul>
            {weekly.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </article>
      </div>
    </div>
  </section>
);

export default ExecutionPlanSection;
